function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEventCelebrationFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.45 7.925l1.775-1.275 2.2-.1-1.275-1.775-.1-2.2-1.775 1.275-2.2.1 1.275 1.775.1 2.2zM7.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM23.5 26a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM25.25 13.8L27 15.1l2.2.15L27.9 17l-.15 2.2L26 17.9l-2.2-.15L25.1 16l.15-2.2zM26.55 10.3L24 9.55l-2.55.75.75-2.55-.75-2.55 2.55.75 2.55-.75-.75 2.55.75 2.55zM21.73 17.56l-3.684 1.855.9 1.786 3.684-1.855-.9-1.787zM10.496 12.8l1.825-3.7 1.794.885-1.825 3.7-1.794-.885z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.55 15a.937.937 0 00-.775-.05c-.25.075-.45.275-.575.5L3.5 26.975c-.2.375-.125.85.2 1.15.2.2.45.3.7.3.15 0 .3-.025.45-.1L16.3 22.55c.225-.125.425-.325.5-.575.075-.25.05-.525-.05-.775a14.027 14.027 0 00-6.2-6.2zM6.625 25.175l3.9-7.9c1.6.975 2.95 2.35 3.95 3.95l-7.85 3.95z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.743 15.341l4.196-4.392 1.446 1.381-4.196 4.393-1.446-1.381z",
    fill: props.color
  }));
}

export default SvgIconEventCelebrationFilled;